<template>
	<div class="history_list_item">
		<div class="history_list_item_time">{{ time }}</div>
		<div class="history_list_item_content">
			<div class="left">
				<div style="margin-bottom:5px" v-for="(item,index) in list" :key="index">
					<div class="label" v-if="item.label">{{ item.label }}</div>
					<div class="cotent">
						<span>{{ item.number }}{{ item.unit }}</span>
						<span
							class="tag bg-primary"
							:class="`tag_${item.status}`"
							v-if="item.status"
							>{{ $status.bloodStatusStr[item.status] }}</span
						>
					</div>
					<div v-if="item.other" class="other">{{item.other }}</div>
				</div>
			</div>
			<div class="right">
				<div class="button_base text-primary" v-if="showUpdate" @click="onUpdate"> 编辑 </div>
				<div class="button_base text-danger" v-if="showDelete" @click="onDelete"> 删除 </div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
    name: 'HistoryListItem',
    props: {
        time: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        other: {
            type: String,
            default: ''
        },
        number: {
            type: [String, Number],
            default: ''
        },
        unit: {
            type: String,
            default: ''
        },
        status: {
            type: [String, Number],
            default: ''
        },
        showDelete: {
            type: Boolean,
            default: false
        },
        showUpdate: {
            type: Boolean,
            default: false
        },
        list: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        onUpdate () {
            this.$emit('onUpdate')
        },
        onDelete () {
            this.$emit('onDelete')
        }
    }
}
</script>
<style lang="less" scoped>
.history_list_item {
	display: flex;
	margin-bottom: 28px;
	&_time {
		padding-left: 22px;
		font-size: 24px;
		color: #8f959e;
		width: 122px;
		line-height: 50px;
	}
	&_content {
		padding: 0 8px 50px 8px;
		border-bottom: 2px solid #f0f0f0;
		flex: 1;
		display: flex;
		.left {
			flex: 1;
		}
		.right {
			display: flex;
			align-items: center;
		}
		.label {
			color: #8f959e;
			font-size: 24px;
			margin-bottom: 8px;
		}
		.other {
			font-size: 24px;
			color: #8f959e;
			margin-top: 5px;
		}
		.cotent {
			font-size: 32px;
			color: #000000;
			display: flex;
			align-items: center;
		}
		.tag {
			font-size: 18px;
			color: #ffffff;
			height: 26px;
			line-height: 26px;
			padding: 4px;
			border-radius: 4px;
			margin-left: 12px;
			display: block;
			&_high {
				background-color: @danger;
			}
			&_normal {
				background-color: @primary;
			}
			&_low {
				background-color: @info;
			}
		}
		.button_base {
			font-size: 26px;
			margin-left: 40px;
			text-align: right;
		}
	}
	&:last-child {
		margin-bottom: 0;
		.history_list_item_content {
			border-bottom: 0;
		}
	}
}
</style>
